import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { MessageCircle, Phone } from "lucide-react"
import * as styles from "../styles/header.module.css"

const Header = () => {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30)
    }
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const toggleMenu = () => setMenuOpen(!menuOpen)
  const closeMenu = () => setMenuOpen(false)

  return (
    <header className={`${styles.header} ${scrolled ? styles.scrolled : ""}`}>
      <div className={styles.headerInner}>
        <Link to="/" className={styles.logo}>
          <StaticImage
            src="../images/logo-salvia.png"
            alt="Dott.ssa Lisa Parri"
            height={45}
            placeholder="none"
            quality={95}
          />
          <div className={styles.logoTextWrapper}>
            <span className={styles.logoText}>Dott.ssa Lisa Parri</span>
            <span className={styles.logoSubtext}>Biologa Nutrizionista</span>
          </div>
        </Link>

        <nav className={`${styles.navLinks} ${menuOpen ? styles.open : ""}`}>
          <Link to="/servizi" activeClassName={styles.activeLink} onClick={closeMenu}>Servizi</Link>
          <Link to="/chi-sono" activeClassName={styles.activeLink} onClick={closeMenu}>Chi Sono</Link>
          <Link to="/contatti" activeClassName={styles.activeLink} onClick={closeMenu}>Contatti</Link>
          <div className={styles.ctaWrapper}>
            <button className={styles.navCta}>Prenota Visita</button>
            <div className={styles.ctaDropdown}>
              <a href="https://wa.me/393886591205?text=Ciao%2C%20vorrei%20prenotare%20una%20visita%20nutrizionale" target="_blank" rel="noopener noreferrer">
                <MessageCircle size={18} /> Scrivimi su WhatsApp
              </a>
              <a href="tel:+393886591205">
                <Phone size={18} /> Chiamami
              </a>
            </div>
          </div>
        </nav>

        {/* Mobile menu popover */}
        <div className={`${styles.mobileMenu} ${menuOpen ? styles.mobileMenuOpen : ""}`}>
          <div className={styles.mobileMenuLinks}>
            <Link to="/servizi" activeClassName={styles.activeLinkMobile} onClick={closeMenu}>Servizi</Link>
            <Link to="/chi-sono" activeClassName={styles.activeLinkMobile} onClick={closeMenu}>Chi Sono</Link>
            <Link to="/contatti" activeClassName={styles.activeLinkMobile} onClick={closeMenu}>Contatti</Link>
          </div>
          <div className={styles.mobileMenuCtaSection}>
            <span className={styles.mobileMenuCtaLabel}>Prenota una Visita</span>
            <div className={styles.mobileMenuCtaButtons}>
              <a href="https://wa.me/393886591205?text=Ciao%2C%20vorrei%20prenotare%20una%20visita%20nutrizionale" target="_blank" rel="noopener noreferrer" className={styles.mobileMenuCtaPrimary} onClick={closeMenu}>
                Scrivimi su WhatsApp
              </a>
              <a href="tel:+393886591205" className={styles.mobileMenuCtaOutline} onClick={closeMenu}>
                Chiamami
              </a>
            </div>
          </div>
        </div>

        <button
          className={`${styles.menuToggle} ${menuOpen ? styles.open : ""}`}
          onClick={toggleMenu}
          aria-label="Apri menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  )
}

export default Header
